<template>
	<v-card class="mx-auto border-radius0" height="100vh" elevation="0">
		<v-card-title class="card-header text-left">
			<v-row>
				<v-col cols="10">
					<v-toolbar-title>{{ $t('editMedicalTeam') }}</v-toolbar-title>
				</v-col>
				<v-spacer></v-spacer>
				<v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text id="EditTeamDrawerMainContianer" class="pa-3 overflow-auto" style="height: calc(100vh - 130px)">
			<v-container class="pa-0 ma-0" style="height: auto">
				<v-text-field
					class="mb-4 border-radius4"
					v-if="checker"
					v-model="getMedicalTeam[0].medicalTeamTitle"
					:label="$t('team-title')"
					outlined
					hide-details
					@input="handleChangedTitleDescription"
					dense></v-text-field>
				<v-textarea
					class="border-radius4"
					v-if="checker"
					v-model="getMedicalTeam[0].medicalTeamDescription"
					:label="$t('description')"
					outlined
					hide-details
					@input="handleChangedTitleDescription"
					dense
					no-resize></v-textarea>
			</v-container>
			<v-container class="pa-0 ma-0" style="height: 80%">
				<h6 class="heading text-left py-2">{{ $t('available-staff') }}</h6>

				<v-text-field
					class="mb-0 pb-3 pt-2"
					:label="$t('filter-staff')"
					v-model="searchStaff"
					prepend-inner-icon="mdi-magnify"
					dense
					hide-details />

				<v-card class="overflow-auto my-0" height="25vh" :loading="availableStaffLoading" outlined style="height: 40%">
					<v-list :key="getMedicalTeam[0].patientId" class="my-0 py-0 custom-style6">
						<p v-if="availableStaff.length === 0" class="pa-4 grey--text text--darken-1">
							{{ $t('no-staff-available') }}
						</p>

						<v-list-item v-for="member in availableStaff" :key="member.id" class="py-0 my-0 custom-border">
							<v-row dense class="pa-0 ma-0">
								<v-col cols="5" class="justify-start text-left d-flex align-start pa-0 ma-0">
									<v-list-item-content class="pa-0 ma-0">
										<v-list-item-title class="pa-0 ma-0">
											<h6 class="font-size12-5">{{ member.firstName }} {{ member.lastName }}</h6>
										</v-list-item-title>
									</v-list-item-content>
								</v-col>
								<v-col cols="3" class="text-left justify-end d-flex pa-0 ma-0">
									<v-list-item-content class="font-weight2 pa-0 ma-0">
										<v-list-item-title class="font-size12-5 color-black pa-0 ma-0">
											{{ member.roleId === 3 ? $t('doctor') : $t('nurse') }}</v-list-item-title
										>
									</v-list-item-content>
								</v-col>
								<v-col class="justify-end d-flex align-center" cols="4">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon @click="addToAssignedStaff(member)" size="21" v-bind="attrs" v-on="on" color="green"
												>mdi-plus-circle</v-icon
											>
										</template>
										<span>{{ $t('assign') }}</span>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-list-item>
					</v-list>
				</v-card>

				<v-container fluid class="pa-0 ma-0 text-left">
					<h6 class="heading py-2" :class="$vuetify.breakpoint.mdAndDown ? 'font-responsive-sm' : 'font-responsive-md'">
						{{ $t('assigned-team') }}
					</h6>
				</v-container>

				<v-card class="overflow-auto my-0" :loading="assignedStaffLoading" outlined style="height: 40%">
					<v-list class="my-0 py-0 custom-style6">
						<p v-if="medicalTeam.length === 0" class="pa-4 grey--text text--darken-1">
							{{ $t('no-staff-assigned') }}
						</p>

						<v-list-item v-for="member in medicalTeam" :key="member.id" class="py-0 my-0 custom-border">
							<v-row dense class="pa-0 ma-0">
								<v-col cols="5" class="justify-start text-left d-flex align-start pa-0 ma-0">
									<v-list-item-content>
										<v-list-item-title>
											<h6 class="font-size12-5">{{ member.firstName }} {{ member.lastName }}</h6>
										</v-list-item-title>
									</v-list-item-content>
								</v-col>
								<v-col cols="3" class="text-left justify-end d-flex pa-0 ma-0">
									<v-list-item-content class="font-weight2">
										<v-list-item-subtitle class="font-size12-5 color-black">
											{{
												member.roleId === 3 && member.id === primaryDoctorId
													? $t('primary-doctor')
													: member.roleId === 3
													? $t('doctor')
													: $t('nurse')
											}}</v-list-item-subtitle
										>
									</v-list-item-content>
								</v-col>
								<v-col class="justify-end d-flex align-center pa-0 ma-0" cols="4">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-switch
												v-bind="attrs"
												v-on="on"
												v-if="member.roleId === 3"
												:input-value="member.id === primaryDoctorId"
												color="gray"
												class="mr-3"
												:disabled="member.id === primaryDoctorId"
												@change="primaryDoctorId = member.id">
											</v-switch>
										</template>
										<span>{{ $t('make-primary') }}</span>
									</v-tooltip>

									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												@click="removeFromAssignedStaff(member)"
												size="21"
												:disabled="member.id === primaryDoctorId"
												v-bind="attrs"
												v-on="on"
												color="primary"
												>mdi-minus-circle</v-icon
											>
										</template>
										<span>{{ $t('dismiss') }}</span>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-list-item>
					</v-list>
				</v-card>
			</v-container>
		</v-card-text>
		<v-card-actions class="mb-0 pb-0 fixed-card-actions">
			<v-row dense class="mb-0 background-white">
				<v-col cols="6">
					<v-btn @click="closeDrawer" elevation="0" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn
						class="save-button-style"
						:disabled="
							!changedTitleDescription && !changedStaff && primaryDoctorId === getMedicalTeam[0]?.primaryDoctorId
						"
						@click="updateMedicalTeam">
						<span>{{ $t('save') }}</span>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
	data () {
		return {
			message: '',
			showMessage: false,
			newDescription: '',
			changedStaff: false,
			staffToAdd: [],
			stafftoRemove: [],
			medicalTeam: [],
			searchStaff: '',
			primaryDoctorId: '',
			changedTitleDescription: false,
			availableStaffLoading: false,
			assignedStaffLoading: false,
		};
	},

	computed: {
		...mapState({
			userDetails: (state) => state.authentication.userData,
		}),
		...mapGetters({
			getUser: 'authentication/getUser',
			getMedicalTeam: 'medicalteam/getMedicalTeam',
			getDoctorAndNurse: 'hospitals/getDoctorAndNurse',
			delay: 'authentication/getDelay',
			roleName: 'authentication/getRole',
		}),

		testHeight () {
			// Adjustments for common resolutions
			if (this.$vuetify.breakpoint.width <= 1280 && this.$vuetify.breakpoint.height <= 720) {
				return '220'; // 1280x720 or lower
			}
			if (this.$vuetify.breakpoint.width <= 1366 && this.$vuetify.breakpoint.height <= 768) {
				return '230'; // 1366x768 or lower
			}
			if (this.$vuetify.breakpoint.width <= 1440 && this.$vuetify.breakpoint.height <= 900) {
				return '280'; // 1440x900 or lower
			}
			if (this.$vuetify.breakpoint.width <= 1600 && this.$vuetify.breakpoint.height <= 900) {
				return '320'; // 1600x900 or lower
			}
			if (this.$vuetify.breakpoint.width <= 1920 && this.$vuetify.breakpoint.height <= 1080) {
				return '410'; // 1920x1080 or lower
			}
			if (this.$vuetify.breakpoint.width <= 1920 && this.$vuetify.breakpoint.height <= 1200) {
				return '450'; // 1920x1200 or lower
			}
			if (this.$vuetify.breakpoint.xl) {
				return '520'; // 2560x1440 or higher
			}
			// Default value for resolutions not specified above
			return '400';
		},

		availableStaff () {
			this.availableStaffLoading = true;
			const staff =
				this.getDoctorAndNurse?.filter((user) => {
					const isAssigned = this.medicalTeam.some((m) => m.id === user.id);
					return (user.roleId === 3 || user.roleId === 4) && !isAssigned;
				}) || [];

			if (!this.searchStaff) {
				this.availableStaffLoading = false;

				return staff;
			}

			const searchTerm = this.searchStaff.toLowerCase();
			return staff.filter((user) => {
				const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
				this.availableStaffLoading = false;

				return fullName.includes(searchTerm);
			});
		},

		filteredPatient () {
			// This is now redundant since availableStaff is now a computed property
			return this.getMedicalTeam.flatMap((patient) => patient.membersList.map((member) => member.id));
		},

		checker () {
			return this.getMedicalTeam && this.getMedicalTeam[0];
		},
	},

	mounted () {
		this.assignedStaffLoading = true;
		if (this.checker) {
			this.primaryDoctorId = this.getMedicalTeam[0].primaryDoctorId;
			this.medicalTeam = JSON.parse(JSON.stringify(this.getMedicalTeam[0].membersList));
		}
		this.assignedStaffLoading = false;
	},

	watch: {
		getMedicalTeam (newMedicalTeam) {
			this.assignedStaffloading = true;
			if (newMedicalTeam && newMedicalTeam.length > 0) {
				this.primaryDoctorId = newMedicalTeam[0].primaryDoctorId;
				this.medicalTeam = JSON.parse(JSON.stringify(this.getMedicalTeam[0].membersList));
			}
			this.assignedStaffLoading = false;
		},
	},

	methods: {
		// ... (your existing methods here, no changes needed)
		async getMedicalTeams () {
			this.loading = true;
			await this.$store.dispatch('medicalteam/getMedicalTeams', this.getUser.hospitalAssignedData.id);
			this.loading = false;
		},

		haveSameObjectsById (arr1, arr2) {
			// The method is already in good shape
			if (arr1.length !== arr2.length) {
				return false;
			}
			const ids1 = new Set(arr1.map((obj) => obj.id));
			const ids2 = new Set(arr2.map((obj) => obj.id));

			if (ids1.size !== ids2.size) {
				return false;
			}

			for (const id of ids1) {
				if (!ids2.has(id)) {
					return false;
				}
			}
			return true;
		},

		handleMessage () {
			this.showMessage = true;
			this.message = 'Cant Change Patient Name';
			setTimeout(() => {
				this.message = '';
				this.showMessage = false;
			}, 3000);
		},

		addToAssignedStaff (member) {
			if (!this.medicalTeam.includes(member)) {
				// Check for the object directly
				this.medicalTeam.push(member);
			}

			const currentTeamMemberIdIndex = this.getMedicalTeam[0].membersList.findIndex((m) => m.id === member.id);
			if (currentTeamMemberIdIndex === -1) {
				this.staffToAdd.push(member.id);
			}

			const removeIndex = this.stafftoRemove.indexOf(member.id);
			if (removeIndex !== -1) {
				this.stafftoRemove.splice(removeIndex, 1);
			}

			this.changedStaff = !this.haveSameObjectsById(this.medicalTeam, this.getMedicalTeam[0]);
		},

		removeFromAssignedStaff (member) {
			const index = this.medicalTeam.findIndex((m) => m.id === member.id);
			if (index !== -1) {
				this.medicalTeam.splice(index, 1);

				const currentTeamMemberIdIndex = this.getMedicalTeam[0].membersList.findIndex((m) => m.id === member.id);
				if (currentTeamMemberIdIndex !== -1) {
					this.stafftoRemove.push(member.id);
				}
				const addIndex = this.staffToAdd.indexOf(member.id);
				if (addIndex !== -1) {
					this.staffToAdd.splice(addIndex, 1);
				}
			}
			this.changedStaff = !this.haveSameObjectsById(this.medicalTeam, this.getMedicalTeam[0]);
		},

		handleChangedTitleDescription () {
			this.changedTitleDescription = true;
		},

		// async changePrimaryDoctor (id) {
		// this.primaryDoctorId = id;
		// const body = {
		// status: 1,
		// hospitalId: this.hospitalId,
		// patientId: this.getMedicalTeam[0].patientId,
		// primaryDoctorId: id,
		// };
		// await this.$store.dispatch('medicalteam/editMedicalTeam', body).then(() => {
		// this.$store.commit('alerts/add', {
		// id: 'updateMedicalTeam',
		// type: 'success',
		// color: 'green',
		// message: this.$t('updatedPrimaryDoctor'),
		// });
		// this.$store.dispatch('alerts/clearWithDelay', this.delay);
		// });
		// await this.$store.dispatch('medicalteam/getMedicalTeamForPatient', this.getMedicalTeam[0].patientId);
		// },

		async updateDescriptionAndTitle (description, title) {
			const body = {
				hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
				patientId: this.getMedicalTeam[0].patientId,
				primaryDoctorId: this.getMedicalTeam[0].primaryDoctorId,
				medicalTeamTitle: title,
				medicalTeamDescription: description,
				status: 1,
			};
			await this.$store.dispatch('medicalteam/editMedicalTeam', body).then(() => {
				this.$store.commit('alerts/add', {
					id: 'updateMedicalTeam',
					type: 'success',
					color: 'green',
					message: this.$t('updatedDescAndTitle'),
				});
				this.$store.dispatch('alerts/clearWithDelay', this.delay);
			});
		},

		async assignMembersToMedicalTeam (medicalTeamIds) {
			const bodyAssign = {
				medicalTeamId: medicalTeamIds,
				memberUserIdList: this.staffSelected,
			};
			await this.$store.dispatch('medicalteam/assignMultipleMembersToMedicalTeam', bodyAssign);
			this.$emit('false');
		},

		async updateMedicalTeam () {
			if (this.changedTitleDescription) {
				await this.updateDescriptionAndTitle(
					this.getMedicalTeam[0].medicalTeamDescription,
					this.getMedicalTeam[0].medicalTeamTitle,
				);
			}
			this.changedTitleDescription = false;

			if (this.primaryDoctorId !== this.getMedicalTeam[0].primaryDoctorId) {
				const body = {
					status: 1,
				hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
					patientId: this.getMedicalTeam[0].patientId,
					primaryDoctorId: this.primaryDoctorId,
				};
				await this.$store.dispatch('medicalteam/editMedicalTeam', body).then(() => {
					this.$store.commit('alerts/add', {
						id: 'updateMedicalTeam',
						type: 'success',
						color: 'green',
						message: this.$t('updatedPrimaryDoctor'),
					});
					this.$store.dispatch('alerts/clearWithDelay', this.delay);
				});
				await this.$store.dispatch('medicalteam/getMedicalTeamForPatient', this.getMedicalTeam[0].patientId);
			}

			if (this.changedStaff) {
				if (this.staffToAdd.length > 0) {
					const bodyAdd = {
						medicalTeamId: this.getMedicalTeam[0].id,
						memberUserIdList: this.staffToAdd,
					};
					await this.$store.dispatch('medicalteam/assignMultipleMembersToMedicalTeam', bodyAdd);
				}
				if (this.stafftoRemove.length > 0) {
					const bodyDelete = {
						medicalTeamId: this.getMedicalTeam[0].id,
						memberUserIdList: this.stafftoRemove,
					};
					await this.$store.dispatch('medicalteam/deassignMultipleMembersFromMedicalTeam', bodyDelete);
				}
			}
			this.closeDrawer();
		},

		async closeDrawer () {
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
			this.changedStaff = false;
			this.staffToAdd = [];
			this.stafftoRemove = [];

			await this.getMedicalTeams();
		},
	},
};
</script>
